<template>
    <div
        class="module-controls"
        :class="{
            'module-controls--vertical-large': variant === 'vertical'
        }"
    >
        <NuxtLink
            v-if="nextItem?.uri"
            class="module-controls__link"
            :class="variant ? 'module-controls__link--' + variant : ''"
            :to="prefixInternalLink(nextItem?.uri)"
            @click="handleNextItem"
        >
            <BaseButton class="full-width">
                {{ nextText ?? 'Continue' }}
            </BaseButton>
        </NuxtLink>

        <NuxtLink
            v-if="exitItem?.uri"
            class="module-controls__link module-controls__link--light"
            :to="prefixInternalLink(exitItem?.uri)"
            @click="handleExit"
        >
            <BaseButton class="full-width">
                {{ exitText ?? 'Exit' }}
            </BaseButton>
        </NuxtLink>

        <NuxtLink
            v-if="skipItem?.uri"
            class="module-controls__link module-controls__link--secondary"
            :to="prefixInternalLink(skipItem?.uri)"
            @click="handleSkip"
        >
            {{ skipText ?? 'Skip this item' }}
            <BaseIcon icon="chevron-right" />
        </NuxtLink>
    </div>
</template>

<script setup lang="js">
const props = defineProps({
    variant: {
        type: String,
        default: ''
    },
    nextItem: {
        type: Object,
        default: null
    },
    exitItem: {
        type: Object,
        default: null
    },
    exitText: {
        type: String,
        default: ''
    },
    nextText: {
        type: String,
        default: null
    },
    nextAction: {
        type: String,
        default: null
    },
    skipItem: {
        type: Object,
        default: null
    },
    skipText: {
        type: String,
        default: ''
    },
    backItem: {
        type: Object,
        default: null
    },
    backText: {
        type: String,
        default: ''
    },
    currentItem: {
        type: Object,
        default: null
    }
});

const { completeChapterItem, moduleProgress, getModuleTitle } = useProgressStorage();

const { params } = useRoute();

const moduleSlug = computed(() => params?.module);
const chapterSlug = computed(() => params?.chapter);
const itemSlug = computed(() => params?.item);

const prefixInternalLink = (link) => {
    return link.startsWith('/') ? link : `/${link}`;
};
const { trackEvent } = useCustomGtmEvent();

const handleNextItem = () => {
    completeChapterItem(moduleSlug.value, chapterSlug.value, itemSlug.value);

    if (props.nextAction === 'start-module') {
        trackEvent({
            event: 'start_module',
            'module_name': getModuleTitle(moduleSlug.value) || null,
            'module_progress': moduleProgress(moduleSlug.value) || 0,
        });
    } else if (props.nextAction === 'continue-module') {
        trackEvent({
            event: 'continue_module',
            'module_name': getModuleTitle(moduleSlug.value) || null,
            'module_progress': moduleProgress(moduleSlug.value) || null,
        });
    } else {
        if (props.nextItem?.__typename === 'module_end_Entry') {
            trackEvent({
                event: 'complete_module',
                'module_name': getModuleTitle(moduleSlug.value) || null,
                'module_progress': moduleProgress(moduleSlug.value) || null,
            });
        } else if (props.nextItem?.__typename === 'module_chapter_Entry') {
            trackEvent({
                event: 'next_chapter_module',
                'module_name': getModuleTitle(moduleSlug.value) || null,
                'module_progress': moduleProgress(moduleSlug.value) || null,
            });
        } else {
            trackEvent({
                event: 'continue_module',
                'module_name': getModuleTitle(moduleSlug.value) || null,
                'module_progress': moduleProgress(moduleSlug.value) || null,
            });
        }
    }
};

const handleSkip = () => {
    trackEvent({
        event: 'skip_chapter',
        'module_name': getModuleTitle(moduleSlug.value) || null,
        'module_progress': moduleProgress(moduleSlug.value) || null,
    });
};

const handleExit = () => {
    trackEvent({
        event: 'exit_module',
        'module_name': getModuleTitle(moduleSlug.value) || null,
        'module_progress': moduleProgress(moduleSlug.value) || null,
    });
};
</script>

<style lang="less" src="./TheModuleControls.less"></style>
